/**
 * @Author: Daniel Rhees <Daniel>
 * @Date:   2017-01-21T19:19:46-08:00
 * @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-08-21T17:39:53-07:00
 */

import { dimensions, spacing } from '../../../style';
import glamorous from 'glamorous';

const sizes = {
  thin: {
    maxWidth: '420px',
  },

  medium: {
    maxWidth: '640px',
  },
};

const Container = glamorous.div(
  {
    maxWidth: '1070px',
    margin: '0 auto',
  },

  ({ relative }) => {
    return relative ? { position: 'relative' } : null;
  },

  ({ fullWidth }) => {
    return fullWidth
      ? {
          [dimensions.SCREEN_MAX_MD]: {
            padding: '0',
          },
        }
      : null;
  },

  ({ width }) => sizes[width],

  ({ screenTop }) => {
    return screenTop
      ? {
          [dimensions.SCREEN_MIN_MD]: {
            ...spacing.MARGIN_TOP_LG,
            ...spacing.MARGIN_BOTTOM_LG,
          },
        }
      : null;
  },

  ({ spacedBottom }) => {
    return spacedBottom
      ? {
          [dimensions.SCREEN_MAX_MD]: {
            ...spacing.MARGIN_BOTTOM_LG,
          },
        }
      : null;
  }
);

export default Container;



// WEBPACK FOOTER //
// ./src/components/blocks/HeaderNav/Container.js